export default `query getSettingList($keys: [String]){
  getSettingList (keys: $keys){	
    id
    key
    value
  }
}`;
